import { render, staticRenderFns } from "./RulesSelector.vue?vue&type=template&id=6abd0a7c&scoped=true"
import script from "./RulesSelector.vue?vue&type=script&lang=ts"
export * from "./RulesSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abd0a7c",
  null
  
)

export default component.exports